import { render } from "./Article.vue?vue&type=template&id=795719de&scoped=true"
import script from "./Article.vue?vue&type=script&lang=ts"
export * from "./Article.vue?vue&type=script&lang=ts"

import "./Article.vue?vue&type=style&index=0&id=795719de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-795719de"

export default script